<span *ngFor="let i of getLayers(tree.LAYER); let index = index; let last=last;">&nbsp;&nbsp;&nbsp;&nbsp;<span
		*ngIf="last">|--</span></span>
<span [ngClass]="{ 'primary bold': tree.STUDENTS_ID == studentId }">
	<span *ngIf="tree.MSD_NUMBER">{{tree.MSD_NUMBER}}</span>
	<span *ngIf="!tree.MSD_NUMBER">00000000000</span>
</span>
<div *ngFor="let branch of tree.STUDENT_MERGED_TREE_BRANCHES; let i = index;">
	<view-children-merge-tree-branches [tree]="branch" [studentMsdNumber]="studentMsdNumber"
		[studentId]="studentId"></view-children-merge-tree-branches>
</div>